import {
  DEFAULT_ISLAND_KEY,
  getIslandCapabilities,
  resolveIslandArea,
  slugifyGeographyName,
} from 'alakai-aloha-shared';
import { hasInternalPlannerAccess } from './internalPlannerAccess';

export const MULTI_ISLAND_PLANNER_COMING_SOON_PATH = '/coming-soon?feature=multi-island-planner';

export function getHomebaseIslandKey(data, fallback = DEFAULT_ISLAND_KEY) {
  return data?.islandKey || data?.summary?.islandKey || fallback;
}

export function isHomebaseItineraryReady(islandKey) {
  const resolvedIslandKey = islandKey || DEFAULT_ISLAND_KEY;
  return Boolean(
    getIslandCapabilities(resolvedIslandKey)?.tripPlanner ||
    hasInternalPlannerAccess('tripPlanner', resolvedIslandKey)
  );
}

export function getCanonicalAreaTitle(areaName, islandKey = DEFAULT_ISLAND_KEY) {
  return resolveIslandArea(areaName, islandKey)?.title || areaName;
}

export function getHomebaseAreaSlug(areaName, islandKey = DEFAULT_ISLAND_KEY, explicitSlug = null) {
  if (explicitSlug) return explicitSlug;
  const resolvedArea = resolveIslandArea(areaName, islandKey);
  return resolvedArea?.slug || slugifyGeographyName(areaName || '');
}
